import * as React from 'react';
import { SVGProps } from 'react';

const SvgPregnancyDiaryOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <g clipPath="url(#a)">
      <path
        d="M18 12.906c0-2.06-1.182-3.865-2.99-4.69.135-.262.22-.553.22-.863 0-.806-.505-1.518-1.258-1.773l-.587-.2a5.08 5.08 0 0 1-1.981-1.242.463.463 0 0 0-.327-.138h-2.77a.462.462 0 0 0-.437.32L7.391 5.78a3.684 3.684 0 0 0 .3 2.972c.586 1.024.417 2.332-.42 3.255A4.922 4.922 0 0 0 6 15.318c0 .969.28 1.907.809 2.712l1.115 1.761a.46.46 0 0 0 .384.209h5.538c.255 0 .462-.21.462-.469a4.58 4.58 0 0 0-.298-1.607c2.31-.508 3.99-2.551 3.99-5.018Zm-3.723 2c-.186.16-.383.328-.59.51a.457.457 0 0 1-.605 0c-.207-.182-.405-.35-.59-.51-1.08-.925-1.859-1.593-1.859-2.612 0-.971.706-1.732 1.607-1.732.507 0 .883.236 1.145.532a1.493 1.493 0 0 1 1.144-.531c.901 0 1.607.76 1.607 1.73 0 1.094-.952 1.836-1.86 2.613Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgPregnancyDiaryOutlined;
